import { render, staticRenderFns } from "./OpeningBookingDialog.vue?vue&type=template&id=b5b2da32&scoped=true&"
import script from "./OpeningBookingDialog.vue?vue&type=script&lang=ts&"
export * from "./OpeningBookingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OpeningBookingDialog.vue?vue&type=style&index=0&id=b5b2da32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b2da32",
  null
  
)

export default component.exports